// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="(\$ctrl.atmTerminal.id ? 'Update ' : 'Create new ') + 'ATM terminal'" tab="true"></sub-header>

    <form name="\$ctrl.atmTerminalForm">
      <table class="misc-transaction__table table table--generate-row-ids">
        <tbody>
        <tr>
          <td></td>
          <td>Terminal ID</td>
          <td>
            <input
                type="text"
                placeholder="Terminal ID"
                ng-required="true"
                ng-model="\$ctrl.atmTerminal.terminalId"
                minlength="1"
                maxlength="30"/>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Other Code</td>
          <td>
            <input
              type="text"
              placeholder="Other Code"
              ng-model="\$ctrl.atmTerminal.otherCode"
              maxlength="30"/>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>GL Account</td>
          <td>
            <selectize
                required
                options="\$ctrl.ledgerAccounts"
                config="\$ctrl.ledgerAccountSelectConfig"
                ng-model="\$ctrl.atmTerminal.ledgerAccountCode">
            </selectize>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Street</td>
          <td>
            <input
                required
                ng-model="\$ctrl.atmTerminal.street"
                type="text"
                placeholder="Street"
                maxlength="256">
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Barangay</td>
          <td>
            <input
                required
                ng-model="\$ctrl.atmTerminal.barangay"
                type="text"
                placeholder="Barangay"
                maxlength="128">
          </td>
        </tr>
        <tr>
          <td></td>
          <td>City</td>
          <td>
            <input
                required
                ng-model="\$ctrl.atmTerminal.city"
                type="text"
                placeholder="City"
                maxlength="128">
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Province</td>
          <td>
            <input
                required
                ng-model="\$ctrl.atmTerminal.province"
                type="text"
                placeholder="Province"
                maxlength="128">
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Postal code</td>
          <td>
            <input
                required
                ng-model="\$ctrl.atmTerminal.postalCode"
                type="text"
                placeholder="Postal code"
                maxlength="8">
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Remarks</td>
          <td>
            <input
              type="text"
              placeholder="Remarks"
              ng-model="\$ctrl.atmTerminal.remarks"
              maxlength="256"/>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="buttons">
        <button
            class="btn btn-warning"
            ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button
            class="btn btn-danger"
            ng-click="\$ctrl.createOrUpdate()"
            ng-disabled="\$ctrl.atmTerminalForm.\$invalid">
          {{\$ctrl.atmTerminal.id ? 'Update' : 'Create'}}
        </button>
      </div>
    </form>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/atm/details/atm-terminal-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;